import React from 'react';
import moment from 'moment';
import { i18n } from '../services/globalize';

export const COLORS = ['#409166', '#9381F7', '#6c757d', '#EC935B', '#50B8ED', '#518CF4', '#4FD0ED'];

export const RED_COLORS = ['#FF0000', '#CC0000', '#FF3333', '#990000', '#FF6666', '#FFCCCC', '#FF9999'];

export const BLUE_COLORS = [ '#0000FF', '#00FFFF', '#0000CC', '#000099','#6666FF', '#66B2FF', '#CCE5FF'];

const convertToUnixTime = timestamp => moment(timestamp).format('x');

const formatUnixTime = (unixTime, format) => {
	const currentOffset = moment().utcOffset();
	// Guard the format argument: this is passed directly as a recharts `tickFormatter`,
	// and recharts 2 calls that as (value, index) where v1 called it as (value). Without
	// the type check the tick index arrives here as `format` and moment throws
	// "format.match is not a function" for every tick after the first (index 0 is falsy,
	// so it used to fall through to the default and only later ticks blew up).
	const pattern = typeof format === 'string' ? format : 'MMM D';
	return moment(Number(unixTime)).utcOffset(currentOffset).format(pattern);
};

const prepareTimeSeriesData = (data) => {
	return data && data.map(item => {
		const { timestamp, ...rest } = item;
		return {
			timestamp: convertToUnixTime(timestamp),	// convert dates to Unix Timestamp to use with scale='time' type='number'
			...rest
		};
	});
};

const formatPieLegendItem = (value, entry) => `${(entry.payload.percent * 100).toFixed(0)}% ${entry.payload.nameResource ? i18n.t(entry.payload.nameResource) : value}`;

const formatPercentage = value => `${value}%`;

const customTooltip = ({ active, payload, label }) => {
	if (active) {
		return (
			<div className="custom-tooltip">
				<label>{`${payload[0].payload.nameResource ? i18n.t(payload[0].payload.nameResource) : payload[0].name} : ${payload[0].value}`}</label>
			</div>
		);
	}

	return null;
};

function pieContainerHeight(data, minHeight) {
	return data && data.length > 5 ? data.length * 55 : minHeight;
}

function exportCsv(data, filename) {
	if (!data || !data.length) return;

	//if data contaigns key timestamp remove time 
	if (data[0].timestamp) {
		data = data.map(item => ({
			...item,
			timestamp: item.timestamp.split('T')[0] 
		}));
	}

	//remove nameResource if it exists
	data = data.map(item => {
		const { nameResource, ...rest } = item;
		return rest;
	});

	const headers = Object.keys(data[0]).join(",");

	const rows = data.map(row =>
		Object.values(row)
			.map(v => `"${v}"`) // Quote values
			.join(",")
	);

	const csvContent = [headers, ...rows].join("\n");

	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", filename);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};

export default {
	convertToUnixTime,
	formatUnixTime,
	prepareTimeSeriesData,
	formatPieLegendItem,
	formatPercentage,
	customTooltip,
	pieContainerHeight,
	exportCsv
};